"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LAYOUT = void 0;
var LAYOUT = {
  // smallMobile: 0,
  // mediumMobile: 414,
  // largeMobile: 600,
  // tablet: 992,
  // desktop: 1200,
  // largeDesktop: 1400,
  smallMobile: 0,
  mobile: 695,
  tablet: 1024,
  desktop: 1400
};
exports.LAYOUT = LAYOUT;